import { render, staticRenderFns } from "./OutgoDetail.vue?vue&type=template&id=515015c7&scoped=true&"
import script from "./OutgoDetail.vue?vue&type=script&lang=js&"
export * from "./OutgoDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutgoDetail.vue?vue&type=style&index=0&id=515015c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515015c7",
  null
  
)

export default component.exports